// What the worktype dropdown says when it has no options to show. Before this,
// a slow or failed work-type fetch and a matter with no work types all read
// "No options", so a Zoho outage looked like missing data (Mads, matter 259559,
// 2026-10-08: the API had lost DNS for five hours).
export function worktypeMenuMessage(status) {
  if (status === 'loading') return 'Loading worktypes...';
  if (status === 'error') return 'Could not load worktypes. Use Retry below the field.';
  return 'No worktypes for this matter';
}
